export default "__VITE_ASSET__DTEiI8U4__"